import { useEffect, useState } from 'react';
import { SidebarItem } from '@backstage/core-components';
import { useApi } from '@backstage/frontend-plugin-api';
import StorageIcon from '@material-ui/icons/Storage';
import { rdsAdminApiRef } from '../../api';

/**
 * Sidebar entry of the RDS admin, shown only to users who may read at least one cluster: the
 * others would land on a page with nothing they can see.
 */
export function RdsAdminSidebarItem() {
  const api = useApi(rdsAdminApiRef);
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    let cancelled = false;
    api
      .getClusters()
      .then(({ clusters }) => {
        if (!cancelled) setVisible(clusters.length > 0);
      })
      .catch(() => {
        if (!cancelled) setVisible(false);
      });
    return () => {
      cancelled = true;
    };
  }, [api]);
  if (!visible) return null;
  return (
    <SidebarItem icon={StorageIcon} to="/rds-admin" text="Bases de données" />
  );
}
